/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IKrannichSupportstickerViewProps } from './krannich-supportsticker';
import { IKrannichSupportstickerConfig, IKrannichSupportstickerResources } from './krannich-supportsticker.props.autogenerated';
import { IContext } from '@msdyn365-commerce/retail-proxy';
import { kRV_GetSalesRepresentativeAsync } from '../../actions/customProxy/SaleRepresentativeSticky/DataActionExtension.g';
import { IKRV_SalesRepresentativeResponseEntity } from '../../actions/customProxy/SaleRepresentativeSticky/DataServiceEntities.g';
// import Modal from 'reactstrap/lib/Modal';
// import { ModalHeader } from 'reactstrap';
// import ModalBody from 'reactstrap/lib/ModalBody';
export interface KrannichSupportStickerFullConfig extends IKrannichSupportstickerConfig {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- This field comes from SDK.
    msdyn365__moduleLayout?: string;
}

export default (props: IKrannichSupportstickerViewProps & IKrannichSupportstickerResources) => {
    const { image, bannerImage, paragraph, stickybanner } = props.config;
    const { salesRepHeading, labelName, labelEmail, labelTelephone } = props.resources;
    const [displayBanner, isDisplayBanner] = React.useState(false);
    const [scroll, setScroll] = React.useState(false);
    const [saleRepresentatativeDetails, setSaleRepresentatativeDetails] = React.useState<IKRV_SalesRepresentativeResponseEntity>({});
    const stickerClassName = props.context.request.telemetryPageName === 'Homepage' ? 'sticker_sticky' : 'sticker';
    const Auth = props.context.request.user.isAuthenticated;

    React.useEffect(() => {
        window.addEventListener('scroll', () => {
            setScroll(window.scrollY > 0);
        });
    }, []);

    React.useEffect(() => {
        const isAuthenticated = props.context.actionContext.requestContext.user.isAuthenticated;
        if (isAuthenticated) {
            const customerAccount = props.context.actionContext.requestContext.user.customerAccountNumber;
            if (customerAccount) {
                void saleRepresentativeDataActionCall({ callerContext: props.context.actionContext }, customerAccount);
            }
        }
    }, []);

    const saleRepresentativeDataActionCall = async (ctx: IContext, customerAccount: string) => {
        try {
            await kRV_GetSalesRepresentativeAsync(ctx, customerAccount).then((salesRepresentativeData: any) => {
                if (salesRepresentativeData?.Name) {
                    setSaleRepresentatativeDetails(salesRepresentativeData);
                } else {
                    setSaleRepresentatativeDetails({});
                }
            });
        } catch (error) {
            setSaleRepresentatativeDetails({});
            console.error('error', error);
        }
    };

    const handleDisplayBanner = () => {
        isDisplayBanner(!displayBanner);
    };
    // const contactSupport = props.contactSupport;
    const imageProps = {
        gridSettings: props.context.request.gridSettings ?? {},
        imageSettings: image?.imageSettings
    };
    const bannerImageProps = {
        gridSettings: props.context.request.gridSettings ?? {},
        imageSettings: bannerImage?.imageSettings
    };
    const defaultImageSettings: Msdyn365.IImageSettings = {
        viewports: {
            xs: { q: 'w=635&h=386&m=6', w: 0, h: 0 },
            lg: { q: 'w=635&h=386&m=6', w: 0, h: 0 }
        },
        lazyload: true
    };
    const paragraphBanner = paragraph && <Msdyn365.RichTextComponent text={paragraph} />;
    return stickybanner ? (
        <div className='row'>
            {!displayBanner && (
                <div className={`${stickerClassName} ${scroll ? 'sticker' : 'sticker_sticky'}`} onClick={handleDisplayBanner}>
                    {/* */}
                    <Msdyn365.Image
                        {...image}
                        {...imageProps}
                        requestContext={props.context.request}
                        editProps={{
                            key: props.config.image ?? {},
                            requestContext: props.context.request,
                            moduleType: props.typeName,
                            imagePropertyName: 'image',
                            moduleId: props.id,
                            layout: (props.config as KrannichSupportStickerFullConfig).msdyn365__moduleLayout
                        }}
                        shouldSkipToMainImage
                    />
                    <div className='sticker-text'>
                        <p>{props.resources.contactConsultantLabel}</p>
                    </div>
                </div>
            )}

            {displayBanner && (
                <div className='support-sticker-banner' onClick={handleDisplayBanner}>
                    <div className='support-sticker-content'>
                        <button className='banner-close' onClick={handleDisplayBanner}>
                            X
                        </button>
                        <div className='banner-image'>
                            <Msdyn365.Image
                                {...bannerImage}
                                {...bannerImageProps}
                                requestContext={props.context.request}
                                imageSettings={defaultImageSettings}
                                editProps={{
                                    key: props.config.bannerImage ?? {},
                                    requestContext: props.context.request,
                                    moduleType: props.typeName,
                                    imagePropertyName: 'bannerImage',
                                    moduleId: props.id,
                                    layout: (props.config as KrannichSupportStickerFullConfig).msdyn365__moduleLayout
                                }}
                                shouldSkipToMainImage
                            />
                        </div>
                        {!Auth || JSON.stringify(saleRepresentatativeDetails) === '{}' ? (
                            <div className='banner-info guest'>{paragraphBanner}</div>
                        ) : (
                            <>
                                <div className='banner-info'>
                                    {saleRepresentatativeDetails?.Name && (
                                        <div className='sale-rep-info'>
                                            <h2>{salesRepHeading}</h2>
                                            <div className='rep-details'>
                                                <div className='detail-line'>
                                                    <span>{labelName}</span>
                                                    {saleRepresentatativeDetails?.Name}
                                                </div>
                                            </div>
                                            {saleRepresentatativeDetails?.Phone !== '' && (
                                                <div className='rep-details'>
                                                    <div className='detail-line'>
                                                        <span>{labelTelephone}</span>
                                                        <a href={`tel:${saleRepresentatativeDetails?.Phone}`}>
                                                            {saleRepresentatativeDetails?.Phone}
                                                        </a>
                                                    </div>
                                                </div>
                                            )}
                                            {saleRepresentatativeDetails?.Email !== '' && (
                                                <div className='rep-details'>
                                                    <div className='detail-line'>
                                                        <span>{labelEmail}</span>
                                                        <a href={`mailto:${saleRepresentatativeDetails?.Email}`}>
                                                            {saleRepresentatativeDetails?.Email}
                                                        </a>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    ) : (
        <div className={stickybanner ? 'support-sticker-banner' : 'support-sticker-banner content-banner'}>
            <div className='support-sticker-content'>
                <div className='banner-image'>
                    <Msdyn365.Image
                        {...bannerImage}
                        {...bannerImageProps}
                        requestContext={props.context.request}
                        imageSettings={defaultImageSettings}
                        editProps={{
                            key: props.config.bannerImage ?? {},
                            requestContext: props.context.request,
                            moduleType: props.typeName,
                            imagePropertyName: 'bannerImage',
                            moduleId: props.id,
                            layout: (props.config as KrannichSupportStickerFullConfig).msdyn365__moduleLayout
                        }}
                        shouldSkipToMainImage
                    />
                </div>
                {!Auth || JSON.stringify(saleRepresentatativeDetails) === '{}' ? (
                    <div className='banner-info guest'>{paragraphBanner}</div>
                ) : (
                    <>
                        <div className='banner-info'>
                            {saleRepresentatativeDetails?.Name && (
                                <div className='sale-rep-info'>
                                    <h2>{salesRepHeading}</h2>
                                    <div className='rep-details'>
                                        <div className='detail-line'>
                                            <span>{labelName}</span>
                                            {saleRepresentatativeDetails?.Name}
                                        </div>
                                    </div>
                                    {saleRepresentatativeDetails?.Phone !== '' && (
                                        <div className='rep-details'>
                                            <div className='detail-line'>
                                                <span>{labelTelephone}</span>
                                                <a href={`tel:${saleRepresentatativeDetails?.Phone}`}>
                                                    {saleRepresentatativeDetails?.Phone}
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                    {saleRepresentatativeDetails?.Email !== '' && (
                                        <div className='rep-details'>
                                            <div className='detail-line'>
                                                <span>{labelEmail}</span>
                                                <a href={`mailto:${saleRepresentatativeDetails?.Email}`}>
                                                    {saleRepresentatativeDetails?.Email}
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
